/** Shared so the bar and the views that leave room for it read the same key. */
export const CONTROL_BAR_HIDDEN_STORAGE_KEY = 'liza:carePlanControlBarHidden';
